import selectors from '../../rootSelectors';

export const types = {
    TRACK_EVENT: 'TRACK_EVENT',
};

const trackEvent = ({ verbId, objectId, elementType, assessment, measure, additionalContext }) => (
    dispatch,
    getStore,
) => {
    const state = getStore();
    const userId = selectors.getUserId(state);
    const isExternalURLSourcePresent = selectors.getExternalURLSourceStatus(state);
    if (isExternalURLSourcePresent) return;
    dispatch({
        type: types.TRACK_EVENT,
        userId,
        verbId,
        objectId,
        elementType,
        assessment,
        measure,
        additionalContext,
    });
};

export const trackStartAssessment = (assessment, measure) => dispatch => {
    dispatch(
        trackEvent({
            verbId: 'pressed',
            objectId: 'StartButton',
            elementType: 'button',
            assessment,
            measure,
        }),
    );
};

export const trackResumeAssessment = (assessment, measure) => dispatch => {
    dispatch(
        trackEvent({
            verbId: 'pressed',
            objectId: 'ResumeButton',
            elementType: 'button',
            assessment,
            measure,
        }),
    );
};

export const trackLogOut = () => dispatch => {
    const additionalContext = {
        'page-url': window.location.href,
    };
    dispatch(
        trackEvent({
            verbId: 'pressed',
            objectId: 'LogOutButton',
            elementType: 'button',
            additionalContext,
        }),
    );
};
